// Third Party
import * as $ from 'jquery';

// Services
import userService from '@/app/services/main/user/user-service.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

// Mixins
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
	name: 'ModalAddUser',
	mixins: [
		dateMixins,
		toastMessageMixins
	],
	data() {
		return {
			inputFields: {
				firstName: '',
				lastName: '',
				email: '',
				selectedTimeZone: 'Australia/Sydney'
			},
			isAPILoading:false
		}
	},
	computed: {
		validationRules() {
			let fields = {
				inputFields: {
					firstName: {},
					lastName: {},
					email: {}
				}
			};

			fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true);
			fields.inputFields = vuelidateUtil.setEmailValidation(fields.inputFields, 'email');
			return fields;
		},
		isDisabled() {
			return this.$v.$invalid;
		},
		authStatus() {
			return this.$store.getters.getAuthMessage;
		}
	},
	methods: {
		show() {
			this.clearFields();
			$(this.$refs.modalAddUser).modal('show');
		},
		setActiveComponent() {
			this.$emit('setActiveComponent', 'add-pet');
		},
		onAddUser() {
			if (this.isDisabled) {
				return;
			}
			
			const userDetails = {
				firstName: this.inputFields.firstName,
				lastName: this.inputFields.lastName,
				email: this.inputFields.email
			};
			
			this.isAPILoading = true;

			userService.postUser(userDetails)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, 'Successfully add new user!');
						this.refreshTable();
						this.isAPILoading = false;
					} else {
						this.showAPIErrorToast(null, res);
						this.isAPILoading = false;
					}
				});
		},
		commitAuthStatus(status, message) {
			this.$store.commit('setAuthMessage', {status, message});
		},
		refreshTable() {
			this.hideModal();
			this.$emit('getTableContent');
		},
		hideModal() {
			this.clearFields();
			$(this.$refs.modalAddUser).modal('hide');
		},
		clearFields() {
			this.inputFields = {
				firstName: '',
				lastName: '',
				email: ''
			};
			this.isAPILoading = false;
			this.$v.$reset();
		},
	},
	validations() {
		return this.validationRules;
	}
}